module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.49b26f95.webp";